import React from "react";
import './loader.css'
export function ComponentLoader(){

    return (
        <div id="new_loader" className="slb-graph-panel-loader">
            <div className="before_page_load">
                <div className="loader_pulse"><div></div><div></div><div></div><div></div><div></div></div>
            </div>
        </div>)
    
    // <div>
    //    <div id="slb_new_loader"> <div className="slb_before_page_load"> <div className="slb_loader_pulse"> <div></div> <div></div> <div></div> <div></div> <div></div> </div><div className="slb_loader_text">Loading</div> </div> </div>
    // </div>
}